import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@app/core/components/button/button.component';

@Component({
  selector: 'pwj-filters-dialog',
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
  templateUrl: './filters-dialog.component.html',
  styleUrl: './filters-dialog.component.scss',
})
export class FiltersDialogComponent {
  titleId = input.required<string>();

  closed = output<void>();
  applied = output<void>();
  removed = output<void>();
}
